import React, {useState} from 'react';
import "react-lazy-load-image-component/src/effects/blur.css";
import '../../Pages/Homepage.css';
import Navbar from '../../commonComponents/Navbar';
import BlogBanner from '../../Componentsss/Blogs/BlogBanner/BlogBanner';
import LatestUpdates from '../../Componentsss/Blogs/LatestUPdates/LatestUpdates';
import BlogForm from '../../Componentsss/Blogs/BlogForm/BlogForm';
import Footer from '../../commonComponents/Footer';
import ConnectForm from '../../Componentsss/Contactus/ConnectForm/ConnectForm';


const Blog = () => {
  const [bannerLoaded, setBannerLoaded] = useState(false);
  return (
    <>
    {bannerLoaded && <Navbar/>}
    <BlogBanner onLoad={() => setBannerLoaded(true)}/>
    {bannerLoaded && (
      <>
        <LatestUpdates/>
        <ConnectForm />
        <Footer/>
      </>
    )}
    
    </>
  )
}

export default Blog